// test573
(573 && 0);
